<div class="upgrade" *ngIf="canManageBilling || user && !user.is_unlimited_plan">
    <sync-button
        type="filled" [color]="buttonColor" [label]="label"
        [leadAdornment]="!!leadIcon" 
        [leadIconAdornment]="leadIcon" 
        (click)="onUpgradePlan()">
    </sync-button>
</div>